export default ({
    state: {
        showGrid: true,
        typeLayout: 1,
        viewFind: false
    },
    getters: {},
    mutations: {
        /*=============================================================================
         * setShowGrid
         * Controla a exibição dos Slot's [ slot "table","form" ] do FormDetail.vue 
         =============================================================================*/
        setShowGrid(state, payload) {
            state.showGrid = payload
        },
        /*=============================================================================
         * setTypeLayout
         * Controla a exibição dos Tipos de Layout 
         * 1 - Single Page
         * 2 - No Sidebar
         * 3 - Sidebar
         * 4 - Aside
         * 5 - Dashboard 
         =============================================================================*/
         setTypeLayout(state, payload) {
            state.typeLayout = payload
        },
        /*=============================================================================
         * setViewFind
         * Controla a exibição dos componentes na visão Modal  
         =============================================================================*/
         setViewFind(state, payload) {
             if(payload === undefined) {
                state.viewFind = !state.viewFind
             } else {
                 state.viewFind = payload
             }

        },
    }
})
